import * as React from "react";

const SvgIcnFormat = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" {...props}>
        <path
            d="M12.9 13.85a.6.6 0 01.6.6v.3a.6.6 0 01-.6.6H3.1a.6.6 0 01-.6-.6v-.3a.6.6 0 01.6-.6h9.8zM8.012.65c.331 0 .628.206.743.517l4.01 10.846a.473.473 0 01-.444.637h-.261a.6.6 0 01-.563-.392l-1.26-3.41H5.717l-1.245 3.408a.6.6 0 01-.563.394h-.244a.461.461 0 01-.433-.622l4.037-10.86A.794.794 0 018.012.65zm.047 2a15.302 15.302 0 01-.666 1.907L6 7.65h4L8.778 4.557a19.736 19.736 0 01-.719-1.907z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnFormat;
